import { color, Common } from '@stockbit/ui';
import React from 'react';
import { PinnedPollingLabelContainer } from './styled';

const { IconWrapper, Iconmoon, Text } = Common;

interface PollingPinnedLabelProps {
  children: React.ReactNode;
  onClick: () => any;
  isActive: boolean;
  [key: string]: any;
}

function PollingPinnedLabel({ children, onClick, isActive, ...props }: PollingPinnedLabelProps) {
  return (
    <PinnedPollingLabelContainer onClick={onClick} {...props}>
      <IconWrapper size="20px">
        <Iconmoon
          className={`icon-toolbar_pinned${isActive ? '-fill' : ''}`}
          size="20px"
        />
      </IconWrapper>
      <Text size="14px" color={color.midgray}>
        {children}
      </Text>
    </PinnedPollingLabelContainer>
  );
}

export default PollingPinnedLabel;
